import { makeStyles } from '@material-ui/core/styles';
import React, { Fragment, useState } from "react";
import './CartItems.css';

const useStyles = makeStyles({
  dialogPaper: {
    borderRadius: '12px !important',
    width: '450px',
    height: '180px',
    transform: 'scale(1)',
    transition: 'transform 0.5s ease-in-out',
    boxShadow: 'none !important',
    backgroundColor: '#fff',
    padding: '20px !important',
    
  },
  
 
  // '@media (max-width: 600px)': {
  //   dialogPaper: {
  //     // CSS styles specific to max-width 600px
  //     // For example:
  //     width: '100vw',
  //     height: '100vh',
  //     maxWidth: 'none',
  //     maxHeight: 'none',
  //     padding: 0,
  //     margin: 0,
  //     margin: '0 !important', // Override margin
  //     maxHeight: '100% !important', // Override max-height
  //     borderRadius: '0 !important',
      
  //   },
  // },
});

function CartItems({props}) {
  // const classes =useStyles();
  console.log('props', props)
  
  const [qty, setQty] = useState(props.qty || 1);
  const [showPopup, setShowPopup] = useState('')

  const { _id, slug, name, description, sellingPrice, price, markedPrice, stock, img, images } = props;

  const onQtyIncrement = () => {
    // if (stock <= qty) {
    //   return;
    // }
    if(!qty > 1){
      setQty(qty + 1);
      props.onQuantityInc(_id, qty + 1);
    }
  };

  const onQtyDecrement = () => {
    if (qty <= 1) return;
    setQty(qty - 1);
    props.onQuantityDec(_id, qty - 1);
  };

  const diff = markedPrice - price;


  const discount = diff / markedPrice * 100;


  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // const loggedUserCart = () => {

  //   if(!isAuthenticated) {
  //     return (
  //       <img src={images[0].url}/>
  //     )
  //   }
  // };



  return (
    <Fragment>
      <div className="mb-2 bg-white lg:p-3 max-lg:p-2 rounded-lg font-bodyPhilosopher w-full">
        <div className="flex gap-4 w-full h-fit ">
          <img src="../../img/myntrasample.jpg" alt="" className="h-32 rounded-md"/>
          <div className="flex flex-col">
            <span className="capitalize">{name}</span>
            <span className="text-sm text-zinc-500 break-words leading-tight">
              {description}
            </span>
            <div className='mt-3'>
              <span className="">₹{price}</span>
              <span className="text-sm line-through text-red-300 ml-2">
                ₹{markedPrice}
              </span>
            </div>
          </div>
        </div>
        <div className="w-full flex justify-end pt-2 bg-white">
          <div className="flex gap-2 text-sm">
            <button className="px-3 py-1.5 rounded-full border hover:bg-red-100 hover:text-red-600 transition-all"
            onClick={()=>setShowPopup('removeItem')}
            >Remove</button>
            <button className="bg-white px-3 py-1.5 rounded-full border"> Save for Later</button>
          </div>
          
        </div>
        {showPopup === 'removeItem' &&
        <div className="fixed inset-0 bg-gray-900 bg-opacity-30 z-1 flex justify-center items-center w-[100vw] backdrop-blur-sm">
          <div className="w-[400px] h-fit overflow-y-auto p-6 rounded-xl  bg-white relative mt-20">
            <p className="mt-2">Are you sure? You might miss it later!</p>
            <div className="flex w-full mt-12 gap-2">
            <button className="flex-1 border h-12 rounded-full hover:bg-blue-50 transition-all"
            onClick={()=>setShowPopup('')}
            >Cancel</button>
            <button className="flex-1 bg-red-50 h-12 border-[1px] border-red-500 rounded-full text-red-600 hover:bg-red-200 transition-all">Remove</button>
            </div>

          </div>
        </div>}
      </div>
    </Fragment>
  );
}

export default CartItems;
